import { useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const cache = new Map();

function keyFor(game) {
  return [
    (game.sport || "").toLowerCase(),
    (game.home_team || "").toLowerCase(),
    (game.away_team || "").toLowerCase(),
    (game.date || "tbd").toLowerCase().slice(0, 10),
  ].join("|");
}

export function useGameBetting() {
  const [state, setState] = useState({}); // gameKey -> { loading, text, odds, error }

  async function load(game) {
    const k = keyFor(game);
    if (state[k]?.text) return state[k];
    if (cache.has(k)) {
      const cached = cache.get(k);
      setState((s) => ({ ...s, [k]: { loading: false, ...cached } }));
      return cached;
    }
    setState((s) => ({ ...s, [k]: { loading: true } }));
    try {
      const r = await axios.post(`${API}/games/betting-insights`, {
        sport: game.sport,
        home_team: game.home_team,
        away_team: game.away_team,
        date: game.date || null,
        time: game.time || null,
        platforms: game.platforms || [],
      }, { timeout: 60000 });
      const payload = { text: r.data?.betting || "", odds: r.data?.odds || null };
      cache.set(k, payload);
      setState((s) => ({ ...s, [k]: { loading: false, ...payload } }));
      return payload;
    } catch (err) {
      const msg = err?.response?.data?.detail || err?.message || "Could not load betting insights.";
      setState((s) => ({ ...s, [k]: { loading: false, error: msg } }));
      return null;
    }
  }

  function getFor(game) {
    return state[keyFor(game)] || {};
  }

  return { load, getFor };
}
